import { render, staticRenderFns } from "./LigasTable.view.vue?vue&type=template&id=479e4af4&scoped=true"
import script from "./LigasTable.view.vue?vue&type=script&lang=js"
export * from "./LigasTable.view.vue?vue&type=script&lang=js"
import style0 from "./LigasTable.view.vue?vue&type=style&index=0&id=479e4af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479e4af4",
  null
  
)

export default component.exports